<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>卡片所属银行查询</h1>
        <p></p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.api.route.hangmuxitong.com</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://api.yunfastpay.com</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
          <div><router-link tag="a" :to="{path:'/interface/zysm'}">下载deom</router-link>
          </div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>AGM0105</td></tr>
          <tr><td>卡bin</td><td>bankCardBin</td><td>String（10）</td><td>是</td><td>取卡号前8位</td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
        <h4>应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>应答码</td><td>respCode</td><td>String（12）</td><td>是</td><td>成功：0000  失败：非0000，具体失败查看描述</td></tr>
          <tr><td>应答描述</td><td>respMsg</td><td>String（512）</td><td>是</td><td>对应应答码信息描述，包含中文</td></tr>
          <tr><td>银行名</td><td>bankName</td><td>String（50）</td><td>否</td><td></td></tr>
          <tr><td>英文简称</td><td>bankNameEn</td><td>String（50）</td><td>否</td><td></td></tr>
          <tr><td>借贷标记</td><td>dcMark</td><td>String（2）</td><td>否</td><td>01：借记卡，00：贷记卡</td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'App',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: [
        {'url': '/interface/kj/kjbk', 'name': '快捷支付接口'},
        {'url': '/interface/base/kbin', 'name': '卡bin查询'}
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/base/kbin.vue